import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";
import dxLinearGauge from "devextreme/viz/linear_gauge";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { Message, PublicMessage } from "../models/message/message";
import { MessageLoad } from "../models/message/message.load";
import { MessageCreate } from "../models/message/message.create";

@Injectable()
export class MessageBackend {
  constructor(
    private httpClient: HttpClient,
    private bootstrapService: BootstrapService
  ) {}

  load(request: MessageLoad): Observable<PaginatedResult<Message>> {
    return this.httpClient
      .get<PaginatedResult<Message>>(
        `${environment.snoots.api.notification}/messages`,
        {
          observe: "body",
          params: {
            ...request
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          docs: response.docs.map((x) => {
            return {
              ...x,
              data: x.data ? JSON.parse(<string>(<any>x.data)) : x.data,
              events: x.events.sort((left, right) =>
                dateUtil(left.createdAt).isBefore(dateUtil(right.createdAt))
                  ? 1
                  : -1
              )
            };
          })
        }))
      );
  }

  loadPublicById(id: string): Observable<PublicMessage> {
    return this.httpClient.get<PublicMessage>(
      `${environment.snoots.api.notification}/public/messages/${id}`
    );
  }

  read(id: string): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.snoots.api.notification}/messages/${id}/read`,
      {}
    );
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.snoots.api.notification}/messages/${id}`,
      {}
    );
  }

  countUnreadNotifications(): Observable<number> {
    return this.load({
      recipient: this.bootstrapService.getCurrentMember()?.id,
      transport: "sse",
      p: 1,
      s: 1000
    }).pipe(
      map((notifications) => notifications.docs.filter((x) => !x.readAt).length)
    );
  }

  getUnreadHighPriorityNotifications(): Observable<Array<Message>> {
    return this.load({
      recipient: this.bootstrapService.getCurrentMember()?.id,
      transport: "sse",
      p: 1,
      s: 1000
    }).pipe(
      map((notifications) =>
        notifications.docs.filter(
          (x) => (x.priority === "high" || x.priority === "medium") && !x.readAt
        )
      )
    );
  }

  createMessage(payload: MessageCreate): Observable<Message> {
    return this.httpClient.post<Message>(
      `${environment.snoots.api.notification}/messages`,
      payload
    );
  }
}
